module.exports = __webpack_public_path__ + "static/media/markerFinish.7a752213.svg";